import { useState } from "react";

const PALETTE = ["#2D4A3E", "#D47C59", "#5C6B62", "#8A6F4E", "#3E6B5C"];

const initials = (name = "") => {
  const parts = name.replace(/[^\p{L}\p{N} ]/gu, "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "G";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
};

const colorFor = (name = "") => PALETTE[[...name].reduce((s, c) => s + c.charCodeAt(0), 0) % PALETTE.length];

/* Google profile photo when we have one; tasteful initials circle otherwise. */
export const Avatar = ({ name, src, size = 36, className = "", testId, initialsTestId }) => {
  const [broken, setBroken] = useState(false);
  const dim = { width: size, height: size, fontSize: Math.round(size * 0.38) };
  if (src && !broken) {
    return (
      <img
        src={src}
        alt={name || "Gardener"}
        referrerPolicy="no-referrer"
        loading="lazy"
        onError={() => setBroken(true)}
        style={dim}
        className={`rounded-full object-cover ring-2 ring-white shadow-sm flex-shrink-0 ${className}`}
        data-testid={testId || "avatar-photo"}
      />
    );
  }
  return (
    <span
      style={{ ...dim, backgroundColor: colorFor(name) }}
      className={`rounded-full inline-flex items-center justify-center text-[#F9F6F0] font-serif font-medium ring-2 ring-white shadow-sm flex-shrink-0 ${className}`}
      aria-label={name || "Gardener"}
      data-testid={initialsTestId || testId || "avatar-initials"}
    >
      {initials(name)}
    </span>
  );
};

export default Avatar;
